import { EXPERIENCE } from './experience'
import currentConferencePhase from './experience/conference'

export const siteConfig = {
  experience: EXPERIENCE,
  conferencePreviewRedirects: currentConferencePhase.preview.redirects,
}
